import { BridgeWarGameSelectorComponent } from '../../features/bridge-war/bridge-war-components';
import { GameEngine } from '../game-engine-helper';
import { GamePhase } from '../../app/types';
import { SFSObject } from 'sfs2x-api';
import { SFSVAR } from '../sfsVar';
import { bridgeWarTitleMap } from '../../app/defaults';
import { sfsService } from '../sfs-service';

export function MID_SHOW_WELCOME(cmdObj: SFSObject, sender: GameEngine) {
    if (sender.props.app.engineStateInterface.lobbyRoom?.containsVariable(SFSVAR.SFSGAME_ROOM_WELCOME_MESSAGE)) {
        sender.setSimpleMessage(
            'center',
            sender.props.app.engineStateInterface.lobbyRoom?.getVariable(SFSVAR.SFSGAME_ROOM_WELCOME_MESSAGE)
                .value as string,
            'OK',
        );
    } else if (sfsService.table.containsVariable('meta')) {
        const metaData: SFSObject = sfsService.table.getVariable('meta').value as SFSObject;
        if (metaData.containsKey('welcome')) {
            sender.setSimpleMessage('center', metaData.getUtfString('welcome'), 'OK');
        }
    }
}

export function MID_SHOW_WELCOME_SB(cmdObj: SFSObject, sender: GameEngine) {
    //
}

export function MID_SHOW_WELCOME_BWAR(cmdObj: SFSObject, sender: GameEngine) {
    //
}
